<template>
<div class="page page_hezuo">
    <div class="bg">欢迎加入时代记忆供应商大家庭</div>
    <!-- 基本信息 -->
    <div>
        <div class="step">
            <!-- 进行状态 加active类 ; 非进行状态 不加-->
            <div class="step_item active">
                <div class="step_name">填写信息</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">审核</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">成功入驻</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
        <!-- 表单 -->
        <div class="form_wrap">
            <div class="item">
                <div class="title">店铺名称</div>
                <div class="name">
                    <van-field v-model="nickname" placeholder="请填写店铺名称" />
                </div>
            </div>
            <div class="item">
                <div class="title">企业名称</div>
                <div class="name">
                    <van-field v-model="company" placeholder="请填写企业名称" />
                </div>
            </div>
            <div class="item">
                <div class="title">企业代码</div>
                <div class="name">
                    <van-field v-model="company_code" placeholder="请填写企业代码" />
                </div>
            </div>
            <div class="item">
                <div class="title">企业类型</div>
                <div class="name">公司</div>
            </div>
            <div class="item flex" @click="fapiaoPicker=true">
                <div class="item_l">
                    <div class="title">发票类型</div>
                    <van-field v-model="fapiaoPickerName" placeholder="选择发票" readonly />
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item flex" @click="areaPicker=true">
                <div class="item_l">
                    <div class="title">省市区</div>
                    <van-field v-model="area" placeholder="请选择" readonly />
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item">
                <div class="title">详细信息</div>
                <div class="name">
                    <van-field v-model="street" placeholder="如道路、门牌号、小区、楼栋号等" />
                </div>
            </div>
            <div class="item">
                <div class="title">店铺头像</div>
                <div class="upload-images">
                    <div class="image_wrap" v-if="company_thumb">
                        <img class="image" :src="imageUrl+company_thumb" />
                    </div>
                    <van-uploader :after-read="upCompanyThumb" accept class="icon-add">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
            <div class="item">
                <div class="title">上传个体工商户营业执照</div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+license" />
                        </div>
                        <div class="img_tip">正面示例</div>
                    </div>
                    <van-uploader :after-read="onLienceRead" accept class="icon-add" ref="license">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
            <div class="item">
                <div class="title">上传资质证书</div>
                <div class="upload-images">
                    <div class="image_wrap" v-if="intelligence">
                        <img class="image" :src="imageUrl+intelligence" />
                    </div>
                    <van-uploader :after-read="upIntelligence" accept class="icon-add">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
            <div class="item">
                <div class="title">上传身份证正反面照片</div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+legal_photo_facade" />
                        </div>
                        <div class="img_tip">正面示例</div>
                    </div>
                    <van-uploader :after-read="onFacadeRead" accept class="icon-add" ref="legal_photo_facade">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
                <div class="upload_images">
                    <!-- 示例图片 -->
                    <div class="img_box">
                        <div class="img_bu">
                            <img class="image" :src="imageUrl+legal_photo_back" />
                        </div>
                        <div class="img_tip">反面示例</div>
                    </div>
                    <van-uploader :after-read="onBackRead" accept class="icon-add" ref="legal_photo_back">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
            <div class="item">
                <div class="title">版权信息</div>
                <div class="upload-images">
                    <div class="image_wrap" v-if="copyRight">
                        <img class="image" :src="imageUrl+copyRight" />
                    </div>
                    <van-uploader :after-read="upCopyrightTu" accept class="icon-add">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
            <div class="item">
                <div class="title">姓名</div>
                <div class="name">
                    <van-field v-model="legal_person" placeholder="请填写您的真实姓名" />
                </div>
            </div>
            <div class="item">
                <div class="title">手机号</div>
                <div class="name">
                    <van-cell :title="phone" />
                </div>
            </div>

        </div>
        <!-- 协议 -->
        <div class="xieyi">
            <van-checkbox v-model="checked_xieyi">
                <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
            </van-checkbox>
            <div class="tips">我已经阅读并同意<span class="xieyi_type" @click="goSinglePage(2)">“供应商入驻协议”</span></div>
        </div>
        <!-- 入驻 -->
        <div class="big_btn" @click="applySeller">入驻</div>
    </div>
    <!-- 地区弹层 -->
    <van-popup v-model="areaPicker" position="bottom">
        <van-area :area-list="areaList" @confirm="confrimArea" @cancel="areaPicker=false" />
    </van-popup>
    <!-- 发票弹层 -->
    <van-popup v-model="fapiaoPicker" position="bottom">
        <van-picker show-toolbar :columns="fapiaoList" value-key="name" @cancel="fapiaoPicker = false" @confirm="confrimFapiao" />
    </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import Field from 'vant';
import {
    Uploader
} from 'vant';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
            checked_xieyi: true,
            invoice: '',
            nickname: '',
            legal_person: '',
            phone: '',
            type: '1', // 企业类型
            street: '',
            area: '',
            area_name1: '1', //省
            area_name2: '2', //市
            area_name3: '3', //区
            areaList: {},
            areaPicker: false,
            token: '',
            legal_photo_facade: '/upload/20260323/20260323145608250.png', //身份证正面照片
            legal_photo_back: '/upload/20260323/20260323145637948.png', //身份证背面照片
            license: '/upload/20260323/20260323145520592.png', //营业执照
            intelligence: '', //资质证书
            company: '', //公司名
            imageUrl: Vue.prototype.$publicData.uploadImage,
            fapiaoPicker: false,
            fapiaoList: [],
            fapiaoPickerName: "",
            imglist: [],
            company_code: '', // 企业代码
            company_thumb: '', // 店铺头像
            copyRight: '', // 版权信息
            status: this.$route.query.status // 0 新增 1编辑
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //设置导航栏
            var params = {
                'data': {
                    'naviTitle': '申请成为供应商'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getUserData()
                    this.getAreaData();
                    this.getFapiaoData();
                    if (this.status == 1) {
                        this.getDetail()
                    }
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getUserData()
            this.getAreaData();
            this.getFapiaoData();
            if (this.status == 1) {
                this.getDetail()
            }
        }
        console.log('this.addressId:' + this.addressId)
        
    },
    methods: {
        getUserData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    this.phone = res.result.info.users.username
                }
            })
        },
        getAreaData() {
            var params = {}
            this.$api.address.areaList(params).then(res => {
                if (res.code == 200) {
                    var area = JSON.parse(res.result)
                    this.areaList = area.areaList;
                } else {
                    this.$toast(res.message)
                }
            })
        },
        getFapiaoData() {
            this.$api.tradesman.fapiaoList({
                token: this.token
            }).then(res => {
                if (res.code == 200) {
                    this.fapiaoList = new Array();
                    var fl = res.result;
                    for (let i = 0; i < fl.length; i++) {
                        var fapiaoId = fl[i].id;
                        var fapiaoName = (fl[i].invoice_type == 0 ? '普票' : '专票') + '（' + '税点：' + fl[i].tax_point + ")";
                        console.log(fapiaoName);
                        this.fapiaoList.push({
                            id: fapiaoId,
                            name: fapiaoName
                        });
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        confrimFapiao(data, index) {
            this.invoice = this.fapiaoList[index].id;
            this.fapiaoPickerName = this.fapiaoList[index].name;
            this.fapiaoPicker = false;
        },
        // 确认选中地区
        confrimArea(data) {
            this.areaPicker = false;
            var area = ''
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                console.log(item);
                if (i == 0) {
                    this.area_name1 = item.code
                } else if (i == 1) {
                    this.area_name2 = item.code
                } else if (i == 2) {
                    this.area_name3 = item.code
                }
                area += item.name
            }
            this.area = area
        },
        // 图片身份证正面上传
        onFacadeRead: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.legal_photo_facade = res.result.url;
                }
            });
        },
        // 图片身份证反面上传
        onBackRead: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.legal_photo_back = res.result.url;
                }
            });
        },
        // 营业执照上传
        onLienceRead: function (file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.license = res.result.url;
                }
            });
        },
        // 上传店铺头像
        upCompanyThumb(file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.company_thumb = res.result.url;
                }
            });
        },
        // 上传资质证书
        upIntelligence(file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.intelligence = res.result.url;
                }
            });
        },
        // 版权信息
        upCopyrightTu(file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.copyRight = res.result.url;
                }
            });
        },
        //入驻按钮
        applySeller() {
            if (!this.nickname) {
                this.$toast('请填写店铺名称');
                return;
            }
            if (this.company == null || this.company == undefined || this.company == '') {
                this.$toast('请填写企业名称');
                return;
            }
            if (!this.company_code) {
                this.$toast('请填写企业代码');
                return;
            }
            if (this.invoice == null || this.invoice == undefined || this.invoice == '') {
                this.$toast('请选发票类型');
                return;
            }
            if (!this.area) {
                this.$toast('请选省市区');
                return;
            }
            if (this.street == null || this.street == undefined || this.street == '') {
                this.$toast('请填写详细地址');
                return;
            }
            if (!this.company_thumb) {
                this.$toast('请上传店铺头像');
                return;
            }
            if (!this.intelligence) {
                this.$toast('请上传资质证书');
                return;
            }
            if (!this.copyRight) {
                this.$toast('请上传版权信息');
                return;
            }
            if (!this.checked_xieyi) {
                this.$toast('请确认勾选协议');
                return;
            }
            var params = {
                token: this.token,
                street: this.street,
                area1: this.area_name1,
                area2: this.area_name2,
                area3: this.area_name3,
                company: this.company,
                type: 1,
                address: this.street,
                legal_photo_facade: this.legal_photo_facade=='/upload/20260323/20260323145608250.png'?'':this.legal_photo_facade,
                legal_photo_back: this.legal_photo_back=='/upload/20260323/20260323145637948.png'?'':this.legal_photo_back,
                company_photo: this.license=='/upload/20260323/20260323145520592.png'?'':this.license,
                name: this.legal_person,
                phone: this.phone,
                sale_invoice_id: this.invoice,
                nickname: this.nickname,
                thumb: this.company_thumb,
                company_code: this.company_code,
                intelligence: this.intelligence,
                copyright: this.copyRight
            }
            this.$api.my.applySeller(params).then(res => {
                if (res.code == 200) {
					this.$toast(res.message)
					var that = this
					this.getApplyStatus(function(){
						if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
							//返回上级页面
							var params = {
								'data': {}
							}
							that.$bridge.callhandler('sdjy://public/back', params, (data) => {

							})
						} else {	
							that.$router.back()
						}
					})
                    
                } else {
                    this.$toast(res.message ? res.message : res.msg)
                }
            })
		},
		// 获取申请角色的审核状态
		getApplyStatus(callback) {
            var params = {
				type: 2, // 1匠人2供应商3代理商4城市合伙人
				token: this.token
			}
			this.$api.my.roleStatus(params).then(res => {
                    if (res.code == 200) {
						//res.result 0认证中1认证通过2未通过3未申请
						localStorage.setItem('seller_apply_status',res.result)
						callback()
                    }
                })
        },
        // 协议  1 平台服务协议;2 供应商入驻协议;3 匠人入驻协议; 4 帮助中心 ; 5合伙人入驻协议; 6 代理商入驻协议
        goSinglePage(id) {
            this.$router.push({
                path: '/single/page',
                query: {
                    id: id
                }
            })
        },
        // 查询供应商审核 未通过再次编辑
        getDetail() {
            var params = {
                token: this.token
            }
            this.$api.my.sellerDetail(params).then(res => {
                if (res.code == 200) {
                    console.log('ok')
                    var obj = res.result
                    // 店铺名称
                    this.nickname = obj.nickname
                    // 公司名
                    this.company = obj.company
                    // 企业代码
                    this.company_code = obj.company_code
                    // 发票
                    this.invoice = obj.sale_invoice_id
                    for (var i in this.fapiaoList) {
                        var fl = this.fapiaoList[i]
                        if (this.invoice == fl.id) {
                            console.log('fl.tax_point-------------', fl)
                            this.fapiaoPickerName = fl.name
                        }
                    }
                    // 省市区
                    this.area_name1 = obj.area1
                    this.area_name2 = obj.area2
                    this.area_name3 = obj.area3
                    this.area = obj.areaname1.areaname + obj.areaname2.areaname + obj.areaname3.areaname
                    // 详细地址
                    this.street = obj.address
                    // 店铺头像
                    this.company_thumb = obj.thumb
                    // 执照
                    if(obj.company_photo&&obj.company_photo!=''){
                        this.license = obj.company_photo
                    }
                    // 资质证书
                    this.intelligence = obj.intelligence
                    // 身份证正面
                    if(obj.legal_photo_facade&&obj.legal_photo_facade!=''){
                        this.legal_photo_facade = obj.legal_photo_facade
                    }
                    // 身份证反面
                    if(obj.legal_photo_back&&obj.legal_photo_back!=''){
                        this.legal_photo_back = obj.legal_photo_back
                    }
                    // 版权信息
                    this.copyRight = obj.copyright
                    // 姓名
                    this.legal_person = obj.name
                    // 手机号
                    this.phone = obj.phone
                }
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
</style>
